import { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import LOGIN_BG from '@assets/images/login-bg.png';
import CRACKLE from '@assets/images/crackle_login.png';
import CRACKLE_LOGO from '@assets/images/crackle_logo_1.svg';
import { useAppSelector } from '@shared/store/hooks';
import type { RootState } from '@shared/store';
import './LoginSignupPage.css';

export default function LoginSignupPage() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const isAuthenticated = useAppSelector((state: RootState) => state.exchange.isAuthenticated);
  const isLoginPage = pathname === '/auth/login';

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/home', { replace: true });
    }
  }, [isAuthenticated, navigate]);

  return (
    <>
      <Helmet>
        <title>Login: Crackle for Demand Partners</title>
      </Helmet>

      <div
        className={`background${isLoginPage ? '' : ' auth-fullscreen'}`}
        style={{
          backgroundImage: `url(${LOGIN_BG})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      >
        {isLoginPage && (
          <div className="mobile-badge">
            <img src={CRACKLE_LOGO} alt="Crackle" />
          </div>
        )}
        <div className="page-container">
          <div className="logo-container">
            <div className="logo-header">
              <img src={CRACKLE} alt="Crackle" className="login-logo" />
              <div className="logo-header-text">exchange</div>
            </div>
            {/* <div className="logo-text">Demand Partners</div> */}
            <div className="logo-footer-text">
              Connecting buyers with high performing digital Ad space
            </div>
          </div>
          <Outlet />
        </div>

        {isLoginPage && (
          <div className="captcha-attribution">
            This site is protected by reCAPTCHA and the Google{' '}
            <a className="captcha-style" href="https://policies.google.com/privacy">
              Privacy Policy
            </a>{' '}
            and{' '}
            <a className="captcha-style" href="https://policies.google.com/terms">
              Terms of Service
            </a>{' '}
            apply.
          </div>
        )}
      </div>
    </>
  );
}
